import React, { useEffect, useState } from "react";
import {
  getCompany,
  getDocumentRequest,
  getInternStudent,
  getInternshipRequest,
  getDocumentReqStudent,
  getJoinDataByCompany,
  getInternshipReject,
} from "../../api/crud";
import _ from "lodash";
import { useSelector } from "react-redux";
import { Avatar, Button, Drawer } from "@mui/material";
import { convertDateThai, matchOptions } from "../../utils/function";
import { optionsBranch } from "../../data/branch-data";
import { internType } from "../../data/interntype-data";
import { BsCheckCircle, BsPencilSquare } from "react-icons/bs";
import DrawerView from "../../Components/DrawerView";
import FormResponse from "../../Components/FormResponse";
import InternPersonsQty from "../../Components/InternPersonsQty";
import ProfileDetail from "../../Components/ProfileDetail";
import InternData from "../../Components/InternData";
import ActivityLog from "../../Components/ActivityLog";
import FormTransfer from "../../Components/FormTransfer";

const InternshipAnswer = () => {
  const optionsStatus = [
    { label: "รอบริษัทตอบรับ", value: "3" },
    { label: "สถานประกอบการรับเข้า", value: "31" },
    { label: "สถานประกอบการไม่รับ", value: "32" },
  ];
  const [isOpenDrawerFormResponse, setIsOpenDrawerFormResponse] =
    useState(false);

  const [docSelected, setDocSelected] = useState(null);
  const profile = useSelector((state) => state.profileReducer.profile);

  const [docRequestList, setDocRequestList] = useState([]);
  const [docRequestFilter, setDocRequestFilter] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowEdit, setRowEdit] = useState(null);
  const [joinDataByCompany, setJoinDataByCompany] = useState([]);
  const [internshipReject, setInternshipReject] = useState([]);
  const [studentSelected, setStudentSelected] = useState(null);

  const [isOpenTransferDrawer, setIsOpenTransferDrawer] = useState(false);

  const onSelectDocResponse = (doc) => {
    setIsOpenDrawerFormResponse(true);
    setDocSelected(doc);
  };

  const onCreateFormTransfer = (doc) => {
    setIsOpenTransferDrawer(true);
    setDocSelected(doc);
  };

  const onHandleSearch = (ev) => {
    const { value } = ev.target;

    setSearchTerm(value);

    const results = docRequestList.filter((el) => {
      return (
        el.idm_doc_id.toLowerCase().includes(value.toLowerCase()) ||
        el.companyDetail.name.toLowerCase().includes(value.toLowerCase())
      );
    });

    setDocRequestFilter(results);
  };

  const getData = async () => {
    const documentRequest = await getDocumentRequest();
    const internStudent = await getInternStudent();
    const allCompany = await getCompany();
    const internshipRequest = await getInternshipRequest();
    const internReject = await getInternshipReject();

    const documentReqStudent = await getDocumentReqStudent();

    const group = _.groupBy(documentReqStudent, (ev) => ev.idm_id);

    const docreqTest = documentRequest.map((item) => {
      return {
        ...item,
        internStd: group[item.idm_doc_id],
      };
    });

    const mapDocreqTest = docreqTest.map((item, iIndex) => {
      return {
        ...item,
        companyDetail: allCompany.find((el) => el.id == item.cp_id),
        internStd: item.internStd.map((el) => {
          const isReject = internReject.find(
            (s) => el.st_id == s.st_id && el.idm_id == s.idm_doc_id
          );

          const student = {
            ...internStudent.find((st) => st.id == el.st_id),
            status_id_2: isReject
              ? "32"
              : internStudent.find((st) => st.id == el.st_id)?.status_id,
            isReject,
          };

          // console.log(el.idm_id, { student, isReject }, Boolean(isReject));

          return {
            ...el,
            internStudent: student,
            internshipRequest: internshipRequest.find(
              (st) => st.st_id == el.st_id
            ),
          };
        }),
      };
    });

    const studentDetail = internStudent.map((st) => {
      const find = internshipRequest.find((el) => el.st_id == st.id);

      return {
        ...st,
        internDetail: find,
      };
    });

    const companyWithStd = allCompany.map((company) => {
      const internSt = studentDetail.filter(
        (st) => st.internDetail?.cp_id == company.id
      );

      return {
        ...company,
        internStudent: internSt,
      };
    });

    const docReq = documentRequest.map((item) => {
      const findCompany = companyWithStd.find((cp) => cp.id == item.cp_id);

      return {
        ...item,
        companyDetail: findCompany,
      };
    });

    const filterData = mapDocreqTest.filter((res) => {
      return res.idm_status == 3;
    });

    console.log({ filterData });

    setDocRequestList(filterData);
    setDocRequestFilter(filterData);
  };

  useEffect(() => {
    getData();

    getJoinDataByCompany().then((res) => {
      setJoinDataByCompany(res);
    });
  }, []);

  return (
    <div className="main">
      <main className="content">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center my-3">
            <h3>แบบตอบรับการฝึกงาน </h3>
            <div>
              <input
                className="form-control"
                placeholder="ค้นหา"
                onChange={onHandleSearch}
                defaultValue={searchTerm}
              />
            </div>
          </div>
          <div className="card flex-fill" style={{ overflowX: "auto" }}>
            <div
              id="datatables-dashboard-projects"
              className="table table-striped my-0 table-hover"
            >
              <thead>
                <tr>
                  <th scope="col" className="border">
                    #
                  </th>
                  <th scope="col" className="border">
                    เลขเอกสาร
                  </th>
                  <th scope="col" className="border">
                    สถานประกอบการ
                  </th>
                  <th scope="col" className="border">
                    รายชื่อนิสิต
                  </th>
                  <th scope="col" className="border"></th>
                </tr>
              </thead>

              {docRequestFilter?.map((res, index) => {
                return (
                  <form
                    key={res.idm_doc_id}
                    className={`tr ${
                      res.internStd[0].internStudent.status_id_2 === "31" &&
                      "bg-success bg-opacity-10"
                    } ${
                      res.internStd[0].internStudent.status_id_2 === "32" &&
                      "bg-danger bg-opacity-10"
                    }`}
                    method="post"
                    action="./update-internship-answer.php"
                  >
                    <td className="border">{index + 1}</td>
                    <td style={{ verticalAlign: "top" }} className="border p-2">
                      <span
                        role="button"
                        onClick={() => onSelectDocResponse(res)}
                        className="as-link"
                      >
                        {res.idm_doc_id}
                      </span>

                      <input
                        name="idm_doc_id"
                        value={res.idm_doc_id}
                        className="d-none"
                      />
                    </td>
                    <td
                      style={{ verticalAlign: "top" }}
                      className="text-wrap border p-2"
                    >
                      <div className="fw-bolder text-dark p-0">
                        {res.companyDetail.name}
                        <InternPersonsQty
                          companyDetail={joinDataByCompany.find(
                            (c) => c.id == res.companyDetail.id
                          )}
                        />
                      </div>
                      <div className="p-0">
                        {res.companyDetail?.address} ต.
                        {res.companyDetail?.subdistrict} อ.
                        {res.companyDetail?.district} จ.
                        {res.companyDetail?.province} {res.companyDetail?.zip}
                      </div>
                      <div className="p-0">
                        <span className="badge bg-secondary ">
                          {matchOptions(internType, res.type_intern)}
                        </span>
                      </div>
                      <div className="p-0">
                        <span className="badge bg-warning text-dark bg-opacity-25">
                          {convertDateThai(res.idm_start_date)} ถึง
                          {convertDateThai(res.idm_end_date)}
                        </span>
                      </div>
                    </td>

                    <td
                      style={{ verticalAlign: "top" }}
                      className="border-bottom p-2"
                    >
                      {res.internStd.map((st, stIndex) => {
                        return (
                          <tr className="border-bottom " key={stIndex}>
                            <td className={`border-bottom `}>
                              <div
                                className="d-flex align-items-center justify-content-between my-2"
                                style={{ width: "500px" }}
                              >
                                <div className="d-flex align-items-center">
                                  <div>
                                    <Avatar
                                      onClick={() => setStudentSelected(st)}
                                      role="button"
                                      alt={st.internStudent.name}
                                      sx={{ height: 25, width: 25, mr: 2 }}
                                      src={`http://reg.buu.ac.th/registrar/getstudentimage.asp?id=${st.internStudent.id}`}
                                    />
                                  </div>
                                  <div>
                                    <div>
                                      {st?.internStudent.name}
                                      <input
                                        className="d-none"
                                        name="st_id[]"
                                        defaultValue={st.internStudent.id}
                                      />
                                      <input
                                        className="d-none"
                                        name="req_id[]"
                                        defaultValue={
                                          st.internshipRequest.req_id
                                        }
                                      />
                                    </div>
                                    <div className="badge bg-info">
                                      {matchOptions(
                                        optionsBranch,
                                        st.internStudent.b_id
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <select
                                    disabled={rowEdit !== index}
                                    className="form-select"
                                    name="ans_id[]"
                                    defaultValue={st.internStudent.status_id_2}
                                  >
                                    {optionsStatus?.map((el) => {
                                      return (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </td>
                    <td className="border p-2">
                      <div className="d-flex">
                        {rowEdit == index && (
                          <>
                            <button className="btn " type="submit">
                              <BsCheckCircle size="1.2rem" color="green" />
                            </button>
                          </>
                        )}
                        <div className="btn ">
                          <BsPencilSquare
                            size="1.2rem"
                            onClick={() =>
                              rowEdit === null
                                ? setRowEdit(index)
                                : setRowEdit(null)
                            }
                          />
                        </div>

                        <input
                          className="d-none"
                          defaultValue={profile?.id}
                          name="user"
                        />
                      </div>

                      {res.internStd.some(
                        (el) => el.internStudent.status_id_2 == "31"
                      ) && (
                        <div>
                          <Button
                            onClick={() => onCreateFormTransfer(res)}
                            sx={{ whiteSpace: "nowrap", fontSize: "10px" }}
                          >
                            พิมพ์หนังสือส่งตัว
                          </Button>
                        </div>
                      )}
                    </td>
                  </form>
                );
              })}
            </div>
          </div>
        </div>
      </main>

      <DrawerView
        isOpen={isOpenTransferDrawer}
        setIsOpen={setIsOpenTransferDrawer}
        content={<FormTransfer docData={docSelected} />}
      />

      <DrawerView
        isOpen={isOpenDrawerFormResponse}
        setIsOpen={setIsOpenDrawerFormResponse}
        content={<FormResponse data={docSelected} editable />}
      />

      <Drawer
        anchor="right"
        open={studentSelected ? true : false}
        onClose={() => setStudentSelected(null)}
      >
        <div
          className="card-body shadow-lg"
          style={{ width: "80vw", maxWidth: "600px" }}
        >
          <div className="row g-0">
            <div className="col-12 mb-4">
              <ProfileDetail st_id={studentSelected?.st_id} />
            </div>
            <div className="col-12 ">
              <InternData st_id={studentSelected?.st_id} />
            </div>
          </div>

          <hr />
          <ActivityLog />
        </div>
      </Drawer>
    </div>
  );
};

export default InternshipAnswer;
